<template>
  <div>
    <BaseVisualBanner
      v-if="!firstStepAnswer"
      :heading="$t('insights.banner.heading_2')"
      :description="$t('insights.banner.description')"
      imagePath="/img/insights/banner.svg"
      :primaryAction="$t('insights.banner.button_text_1')"
      :secondaryAction="$t('insights.banner.button_text_2')"
      theme="light"
      color="green"
      @primaryAction="() => firstStepAnswer = 'yes'"
      @secondaryAction="() => firstStepAnswer = 'no'"
    />
    <BaseVisualBanner
      v-else
      :heading="$t('insights.banner.heading')"
      :description="$t('insights.banner.description')"
      imagePath="/img/insights/banner.svg"
      :primaryAction="{
        text: $t('insights.banner.button_text'),
        href: 'https://portal.productboard.com/salonized/1-salonized-idea-box/tabs/4-ideeen-ideas/submit-idea'
      }"
      theme="light"
      color="green"
    />
  </div>
</template>

<script
  setup
  lang="ts"
>
import { useSessionStorage } from '@vueuse/core';

const firstStepAnswer = useSessionStorage<'yes' | 'no' | null>(
  'insightsBannerFirstStepAnswer',
  null,
);
</script>
